export const removePrefix = (value: string, prefix: string) =>
  value.startsWith(prefix) ? value.slice(prefix.length) : value;

export const isNullOrWhitespace = (value: string | undefined | null) => {
  return value == null || value === undefined || value.match(/^ *$/) !== null;
};

export const splitCapitalLetters = (value: string): string => {
  const rawString = value.split(/(?=[A-Z])/);
  if (rawString === null) return "";
  return rawString.join(" ").toUpperCase();
};
export const capitalizeFirstLetter = (value: string) => {
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const toCurrentIntFormat = (value: string | number): string => {
  if (typeof value === "string") {
    return value;
  }
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
  });
  return formatter.format(value);
};

export const toCurrencyFormat = (value: string | number): string => {
  if (typeof value === "string") {
    return value;
  }
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  return formatter.format(value);
};

export const toNumberFormat = (value: string | number): string => {
  if (typeof value === "string") {
    return value;
  }
  const formatter = new Intl.NumberFormat("en-US");
  return formatter.format(value);
};

export const toDecimalFormat = (value: string | number): string => {
  if (typeof value === "string") {
    return value;
  }
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 1,
  });
  return formatter.format(value);
};
